const getRadioLabelData = (pickup) => {
  return {
    pickup: {
      number: pickup.pickupNumber,
    },
    driver: {
      name: pickup.driverName,
      number: pickup.driverNumber,
      id: pickup.driverId,
    },
    shipper: {
      name: pickup.shipperName,
      accountNumber: pickup.shipperAccountNumber,
      address: pickup.shipperAddress,
    },
  };
};

export { getRadioLabelData };
